// extracted by mini-css-extract-plugin
module.exports = {"supports":"Supports_supports__WuYtA"};